import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { Col, Container, Row } from 'react-bootstrap';
import Logo from '../svg/Logo';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const PageLoader = ({ errorMessage }) => {
  const root = useSelector((store) => store.rootReducer);

  // console.log(root?.page1.error?.message, 'rrot');
  //--- form submit
  const success = (msg) => toast.success(msg, {
    position: 'top-right', autoClose: 4000, closeOnClick: true, progress: undefined,

  });

  const error = (msg) => toast.error(msg, {
    position: 'top-right', autoClose: 4000, closeOnClick: true, progress: undefined,

  });

  const pageKeys = ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11'];
  const loaderRef = useRef(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const logoReveal = useRef(null);
  const logoRevealImg = useRef(null);

  useEffect(() => {
    gsap.set(document.querySelector('.page-loader .logo-wrapper svg'), {
      autoAlpha: 0, // Fades out the logo
    });
  })
  useEffect(() => {

    // Simulate loading progress (increment by a small amount)
    const interval = setInterval(() => {
      setLoadingProgress((prevProgress) => {
        const newProgress = prevProgress + 1;
        if (newProgress >= 100) {
          clearInterval(interval); // Stop when progress reaches 100%
        }
        return newProgress;
      });
    }, 5); // Adjust the interval duration as needed

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {



    pageKeys.map((pageKey, index = 10) => {
      const page = root?.[pageKey];
      if (page?.loading === false) {
        gsap.to(document.querySelector('.page-loader .logo-wrapper svg'), {
          autoAlpha: 0, // Fades out the logo
        },"-=0.5");
        gsap.to(logoReveal?.current, {
          x: `${loadingProgress}%`,
          duration: 0.1, // Adjust the duration as needed for smoother animation
          onUpdate: () => {
            // Update the inner HTML of .p1-font with the loadingProgress value
            logoReveal.current.querySelector('.p1-font').innerHTML = `${Math.floor(loadingProgress)}%`;
            const tl = gsap.timeline();
            tl.to(document.querySelector('.page-loader .logo-wrapper svg'), {
              autoAlpha: 1, // Fades out the logo
            },"-=0.5");
          },
          onComplete: () => {
            // When loadingProgress reaches 100%, start the loader exit animation
            if (loadingProgress >= 100) {
              // Create a GSAP timeline sequence
              const tl = gsap.timeline();

// Add animations to the timeline
              tl.to(loaderRef?.current, {
                delay: 0.5,
                autoAlpha: 0, // Fades out the loader
                height: 0, // Sets the height to 0
                duration: 2, // Duration of the fade-out animation
                onComplete: () => {
                  // Optionally, you can perform some action when the animation is complete.
                },
              }) // Start this animation 0.1 seconds before the previous one ends
                .to(document.querySelector('.page-loader .logo-wrapper svg'), {
                  autoAlpha: 0, // Fades out the logo
                  duration: 1,
                }, '-=2.4')
                // Start this animation 0.1 seconds before the previous one ends
                .to(document.querySelector('.page-loader .logo-wrapper svg'), {
                  autoAlpha: 0, // Fades out the logo
                  duration: 1,
                }, '-=1.4')
                .to(document.querySelector('.page-loader .p1-font'), {
                  autoAlpha: 0, // Fades out the text
                  duration: 1,
                }, '-=2.6'); // Start this animation 0.4 seconds before the previous one ends
              tl.play();

            }
          },
        })
        // gsap.to(document.querySelector('.page-loader .logo-wrapper svg'), {
        //   autoAlpha: 1, // Fades out the logo
        // },"-=0.5");
        ;
      }

    });
  }, [pageKeys]);

  return (
    <div className='page-loader' ref={loaderRef}>
      <Container>
        <Row>

          <Col md={12} className={'text-center log-col'}>
            <div className='logo-wrapper'>
              <div className='cover' ref={logoReveal}>
                <p className='p1-font'>0%</p>
              </div>

              {
                error ?
                  <Logo />
                  :
                  <>
                    <svg ref={logoRevealImg} classNam={'preloader-logo'} xmlns="http://www.w3.org/2000/svg" width="97.321" height="40" viewBox="0 0 97.321 40">
                      <g id="Mask_Group_20097" data-name="Mask Group 20097" transform="translate(-98 -10)">
                        <g id="Group_20096" data-name="Group 20096" transform="translate(98 10)">
                          <path id="Path_9487" data-name="Path 9487" d="M390.209,1059.452l.446.1-1.59,5.005h-14.3v-.5h.692a1.853,1.853,0,0,0,1.673-.758,4.361,4.361,0,0,0,.283-2V1049.33a3.778,3.778,0,0,0-.381-2.161,1.992,1.992,0,0,0-1.575-.6h-.692v-.5h8.365v.5a5.156,5.156,0,0,0-2.068.27,1.651,1.651,0,0,0-.809.711,5.848,5.848,0,0,0-.218,2.059v11.656a3.814,3.814,0,0,0,.218,1.557.968.968,0,0,0,.507.427,9.008,9.008,0,0,0,2.129.135h1.348a9.788,9.788,0,0,0,2.988-.311,3.934,3.934,0,0,0,1.571-1.111,9.184,9.184,0,0,0,1.417-2.51Zm13.8-1.059H396.85l-1.236,2.9a4.669,4.669,0,0,0-.465,1.608.939.939,0,0,0,.4.744,3.564,3.564,0,0,0,1.734.414v.5h-5.828v-.5a3.111,3.111,0,0,0,1.5-.53,8.346,8.346,0,0,0,1.538-2.658l6.5-15.216h.46l6.427,15.378a7.017,7.017,0,0,0,1.408,2.407,2.882,2.882,0,0,0,1.766.618v.5H403.77v-.5a2.75,2.75,0,0,0,1.492-.367.947.947,0,0,0,.386-.767,5.679,5.679,0,0,0-.544-1.9l-1.092-2.63Zm-.418-1-3.114-7.459-3.2,7.459ZM411,1046.067v.5a4.491,4.491,0,0,1,1.2.121,4.638,4.638,0,0,1,1.218.562,8.5,8.5,0,0,1,1.218,1.241v12.855a4.153,4.153,0,0,1-.3,1.994,1.928,1.928,0,0,1-1.7.711h-.651v.5h6.5v-.5h-.66a2.089,2.089,0,0,1-1.617-.572,3.789,3.789,0,0,1-.372-2.133v-11.386L428,1064.852h.493v-15.578a4.152,4.152,0,0,1,.3-1.994,1.915,1.915,0,0,1,1.687-.711h.66v-.5h-6.5v.5h.651a2.057,2.057,0,0,1,1.613.572,3.673,3.673,0,0,1,.386,2.133v10.675l-11.326-13.882Zm37.3-.418.418,6.274H448.3a7.9,7.9,0,0,0-2.4-4.057,5.829,5.829,0,0,0-3.746-1.241,6.073,6.073,0,0,0-3.309.934,6.173,6.173,0,0,0-2.328,2.979,13.377,13.377,0,0,0-.846,5.084,10.835,10.835,0,0,0,.8,4.35,6.041,6.041,0,0,0,2.407,2.821,6.894,6.894,0,0,0,3.667.98,6.349,6.349,0,0,0,3.16-.767,10.349,10.349,0,0,0,3.011-3.053l.423.279a9.692,9.692,0,0,1-3.235,3.6,9.063,9.063,0,0,1-11.479-2.268,9.766,9.766,0,0,1-1.878-5.967,10.645,10.645,0,0,1,1.236-5.085,8.952,8.952,0,0,1,3.4-3.592,9.155,9.155,0,0,1,4.731-1.274,8.639,8.639,0,0,1,3.936.981,2.127,2.127,0,0,0,.813.3.9.9,0,0,0,.637-.26,2.094,2.094,0,0,0,.5-1.022Zm12,0a8.354,8.354,0,0,1,6.223,2.733,9.437,9.437,0,0,1,2.635,6.823,9.714,9.714,0,0,1-2.654,6.99,8.856,8.856,0,0,1-12.822.065,9.732,9.732,0,0,1-2.593-7.018,9.364,9.364,0,0,1,2.993-7.18,8.827,8.827,0,0,1,6.218-2.412Zm-.26.976a4.851,4.851,0,0,0-3.964,1.84q-1.861,2.294-1.864,6.711,0,4.524,1.929,6.966a4.764,4.764,0,0,0,3.913,1.854,5.348,5.348,0,0,0,4.29-2.031q1.694-2.036,1.692-6.409,0-4.747-1.864-7.078A5.007,5.007,0,0,0,460.037,1046.625Z" transform="translate(-374.761 -1038.5)" fill="#f9f9f9" fill-rule="evenodd"/>
                          <path id="Path_9488" data-name="Path 9488" d="M383.557,1323.414v-.8h2.894v2.534a5.115,5.115,0,0,1-1.375.8,4.094,4.094,0,0,1-1.455.267,3.878,3.878,0,0,1-1.831-.431,2.847,2.847,0,0,1-1.241-1.246,3.925,3.925,0,0,1-.42-1.823,4.234,4.234,0,0,1,.417-1.864,2.77,2.77,0,0,1,1.2-1.283,3.757,3.757,0,0,1,1.8-.42,3.563,3.563,0,0,1,1.34.24,2.227,2.227,0,0,1,.939.668,2.965,2.965,0,0,1,.517,1.121l-.817.223a2.6,2.6,0,0,0-.382-.821,1.564,1.564,0,0,0-.653-.478,2.388,2.388,0,0,0-.941-.18,2.777,2.777,0,0,0-1.071.189,1.993,1.993,0,0,0-.729.5,2.364,2.364,0,0,0-.43.676,3.61,3.61,0,0,0-.261,1.378,3.378,3.378,0,0,0,.313,1.534,2.022,2.022,0,0,0,.915.915,2.834,2.834,0,0,0,1.276.3,3.023,3.023,0,0,0,1.146-.228,2.931,2.931,0,0,0,.847-.487v-1.281Zm19.1,2.684v-6.838h3.03a4.036,4.036,0,0,1,1.39.184,1.519,1.519,0,0,1,.759.65,1.939,1.939,0,0,1,.283,1.03,1.722,1.722,0,0,1-.471,1.227,2.379,2.379,0,0,1-1.453.634,2.331,2.331,0,0,1,.546.341,4.586,4.586,0,0,1,.748.91l1.183,1.862h-1.13l-.9-1.423c-.263-.412-.481-.726-.651-.944a2.072,2.072,0,0,0-.46-.457,1.384,1.384,0,0,0-.412-.181,2.812,2.812,0,0,0-.5-.032h-1.047v3.037Zm.907-3.82h1.942a2.88,2.88,0,0,0,.968-.129,1.009,1.009,0,0,0,.528-.411,1.109,1.109,0,0,0,.181-.613,1.024,1.024,0,0,0-.35-.8,1.636,1.636,0,0,0-1.108-.312h-2.161v2.263Zm20.546.492a3.71,3.71,0,0,1,.915-2.663,3.109,3.109,0,0,1,2.36-.961,3.285,3.285,0,0,1,1.708.452,2.95,2.95,0,0,1,1.159,1.26,4.084,4.084,0,0,1,.4,1.832,4.016,4.016,0,0,1-.42,1.859,2.859,2.859,0,0,1-1.189,1.242,3.4,3.4,0,0,1-1.662.422,3.243,3.243,0,0,1-1.727-.466,3,3,0,0,1-1.152-1.272,3.849,3.849,0,0,1-.392-1.7Zm.936.016a2.731,2.731,0,0,0,.664,1.943,2.321,2.321,0,0,0,3.347-.006,2.9,2.9,0,0,0,.659-2.034,3.493,3.493,0,0,0-.282-1.455,2.165,2.165,0,0,0-.824-.963,2.247,2.247,0,0,0-1.219-.342,2.313,2.313,0,0,0-1.652.659,2.936,2.936,0,0,0-.692,2.2Zm26.1-3.526h.907v3.949a4.708,4.708,0,0,1-.232,1.638,2.007,2.007,0,0,1-.84.985,2.975,2.975,0,0,1-1.595.38,3.266,3.266,0,0,1-1.568-.331,1.884,1.884,0,0,1-.871-.958,4.58,4.58,0,0,1-.261-1.714v-3.949h.907v3.947a3.86,3.86,0,0,0,.165,1.313,1.245,1.245,0,0,0,.567.651,1.951,1.951,0,0,0,.982.229,1.876,1.876,0,0,0,1.417-.452,2.62,2.62,0,0,0,.422-1.741v-3.947Zm17.27,6.838v-6.838H471a6.311,6.311,0,0,1,1.041.065,2.074,2.074,0,0,1,.845.318,1.682,1.682,0,0,1,.549.659,2.217,2.217,0,0,1-.349,2.4,2.664,2.664,0,0,1-2.007.6h-1.754v2.789Zm.907-3.591h1.767a1.876,1.876,0,0,0,1.246-.326,1.166,1.166,0,0,0,.368-.92,1.234,1.234,0,0,0-.216-.734,1.018,1.018,0,0,0-.571-.4,3.921,3.921,0,0,0-.844-.061h-1.749Z" transform="translate(-379.623 -1286.212)" fill="#f9f9f9" fill-rule="evenodd"/>
                          <path id="Path_9489" data-name="Path 9489" d="M1347.926,975.007a2.3,2.3,0,1,1,2.335-2.3,2.32,2.32,0,0,1-2.335,2.3Zm2.7-3.429a2.887,2.887,0,0,0-.628-.92,2.944,2.944,0,0,0-4.134,0,2.888,2.888,0,0,0-.628.92,2.876,2.876,0,0,0,0,2.259,2.887,2.887,0,0,0,.628.92,2.944,2.944,0,0,0,4.134,0,2.886,2.886,0,0,0,.628-.92,2.876,2.876,0,0,0,0-2.259Z" transform="translate(-1253.531 -969.812)" fill="#f9f9f9" fill-rule="evenodd"/>
                          <path id="Path_9490" data-name="Path 9490" d="M1364.446,983.361h-.521v-1.008c.119-.01.266-.015.438-.015.589,0,.875.166.875.508s-.259.515-.792.515Zm1.209.739a1.226,1.226,0,0,0-.366-.464.869.869,0,0,0,.526-.817.822.822,0,0,0-.4-.72,1.9,1.9,0,0,0-1.048-.256,6.136,6.136,0,0,0-.981.09l-.05.008v3.311h.592v-1.416h.543a.635.635,0,0,1,.549.327,2.609,2.609,0,0,1,.326,1.037l.007.051h.6l-.011-.069A4.461,4.461,0,0,0,1365.655,984.1Z" transform="translate(-1270.136 -980.709)" fill="#f9f9f9" fill-rule="evenodd"/>
                        </g>
                      </g>
                    </svg>
                  </>
              }
            </div>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageLoader;
